/** Figma 520-4764 (warning) vs 520-4894 (error) — map i18n keys to banner variant. */
const OTP_WARNING_KEYS = new Set(["ONBOARDING_OTP_EXPIRED", "OTP_EXPIRED"]);

export const resolveOtpFeedbackVariant = (messageKey) => {
  if (!messageKey) return null;
  return OTP_WARNING_KEYS.has(messageKey) ? "warning" : "error";
};

export const isOtpErrorVariant = (otpValidationError) =>
  resolveOtpFeedbackVariant(otpValidationError?.message) === "error";
